import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import selectProtectionPlan from './selectProtectionPlan';

const selectAdditionalProtectionPlans = memoize((sourceMiniPDP) =>
    createSelector([selectProtectionPlan(sourceMiniPDP)], (warranties) =>
        warranties.filter((obj) => !obj.selected)
    )
);

export default selectAdditionalProtectionPlans;
